import { render, staticRenderFns } from "./informationList.vue?vue&type=template&id=3b245d3c&scoped=true"
import script from "./informationList.vue?vue&type=script&lang=js"
export * from "./informationList.vue?vue&type=script&lang=js"
import style0 from "./informationList.vue?vue&type=style&index=0&id=3b245d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b245d3c",
  null
  
)

export default component.exports